module.exports = __webpack_public_path__ + "media/Video 124.63dc1242.mp4";